import Vue from "vue";

import { UtilService, DomainService } from '@/libs'

Vue.filter('fileExtIcon', function (value: string) {
  return `${DomainService.PublicPath}resource/images/fileext/${UtilService.getFileExt(value)}.png`;
});

Vue.filter('fileSizeFormat', function(value: number) {
  return UtilService.fileSizeFormat(value);
})